import React from 'react';
import {
	FaBook,
	FaChartBar,
	FaSearch,
	FaUserCog,
	FaWrench,
	FaHandshake
} from 'react-icons/fa'; // Example icons

const HoverRevealList = () => {
	const items = [
		{
			title: 'ACCOMPAGNEMENT',
			description:
				'Quel que soit le type du programme choisi (Installation des unités industrielles ou instauration des processus de fabrication…), nous créerons avec vous les services qui s’adaptent le mieux à vos besoins. ',
			color: '#fcd538',
			icon: <FaWrench />
		},
		{
			title: 'DEVELOPPEMENT',
			description:
				'CFCAE s’engage à vous accompagner pour obtenir tous les agréments (ONEE, REGIES, EQUIPEMENT, HABITAT…) qui vous permettront de se développer selon votre taille et vos moyen humains, matériels, techniques et financiers, ainsi que le montage du dossier de financement. ',
			color: '#1c81ff',
			icon: <FaChartBar />
		},
		{
			title: 'DIAGNOSTIC',
			description:
				'Notre cabinet est à votre écoute pour comprendre vos problématiques et trouver la solution la plus adéquate. Nous travaillons ensemble afin d’arriver à un diagnostic approfondi de votre entreprise.',
			color: '#29e38d',
			icon: <FaSearch />
		},
		{
			title: 'EXPERTISE',
			description:
				'Nous possédons des experts industriels capables d’aider votre entreprise à améliorer le rendement du personnel, rentabiliser la productivité, optimiser les couts et assurer la bonne qualité du service ou produit fabriqué. ',
			color: '#708dff',
			icon: <FaUserCog />
		},
		{
			title: 'FORMATION',
			description:
				'Nos équipes d’experts, riches de leur recherche et expérience terrain, partageront des compétences théoriques et pratiques avec vos collaborateurs sur les Bases de la Sécurité, l’Audit de la Sécurité au travail et l’Habilitation électrique. Nous proposons des formations de qualité destinées aux personnels d’un niveau débutant, intermédiaire ou professionnel. ',
			color: '#520330',
			icon: <FaBook />
		},
		{
			title: 'MEDIATION ET RECOUVREMENT',
			description:
				'CFCAE a joué le rôle du médiateur sur des dossiers de conflits importants et de recouvrements.',
			color: '#DCC6A0',
			icon: <FaHandshake />
		}
	];

	return (
		<div className='flex items-center justify-center w-full'>
			<div className='w-full md:w-[80%] h-full flex flex-col items-center gap-3 justify-center bg-white border-t-[#87152B] border-t-8'>
				<div className='my-8 w-[90%] sm:w-[70%]'>
					<p>
						<span className='font-normal text-[#87152B] md:text-4xl sm:text-3xl text-2xl'>
							N
						</span>
						otre cabinet vous apporte son expertise pour vous
						accompagner vers une performance fondée sur le
						renforcement et la consolidation de votre capital humain
						et le développement de vos projets et vos concepts
						notamment dans les domaines ci-après :
					</p>
				</div>
				<div className='flex flex-wrap items-center justify-center gap-6 p-6 overflow-auto'>
					{items.map((item, index) => (
						<div
							key={index}
							className='relative w-[260px] h-64 flex flex-col items-center justify-center group overflow-hidden hover:scale-110 transition-all duration-500 rounded-lg shadow-lg'
							style={{ backgroundColor: item.color }}
						>
							{/* Icon and Title group-hover:opacity-100 */}
							<div className='flex flex-col items-center justify-center text-xl font-bold text-white  transition-opacity duration-300'>
								<div className='text-4xl mb-2'>{item.icon}</div>
								{/* <div>{item.title}</div> */}
								<div
								className={`${
									item.title === 'MEDIATION ET RECOUVREMENT'
										? 'text-center'
										: ''
								}`}
							>
								{item.title}
							</div>
							</div>

							<div className='absolute top-0 left-0 w-full h-full bg-white text-gray-800 opacity-0 group-hover:opacity-100 p-6 text-center flex items-center justify-center transition-all duration-500 ease-in-out transform scale-0 group-hover:scale-100'>
								<p className='text-sm'>
									<strong className='text-[#87152B]'>
										{item.title} :
									</strong>{' '}
									{item.description}
								</p>
							</div> 
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default HoverRevealList;
